import React from 'react';
import { AnalyticsContext } from '@atlaskit/analytics-next';
import { getResolvedAttributes } from '@atlaskit/link-analytics/resolved-attributes';
import { ANALYTICS_CHANNEL } from '../../../../../../../../utils/analytics';
const createUiRelatedLinksViewedEventPayload = ({
  relatedLinksCount
}) => ({
  action: 'viewed',
  actionSubject: 'relatedLinks',
  eventType: 'ui',
  attributes: {
    relatedLinksCount
  }
});
export const fireRelatedLinksViewedEvent = createAnalyticsEvent => attributes => {
  const payload = createUiRelatedLinksViewedEventPayload(attributes);
  if (payload) {
    createAnalyticsEvent({
      ...payload
    }).fire(ANALYTICS_CHANNEL);
  }
};
export const RelatedUrlItemAnalyticsContext = props => {
  const {
    children,
    details
  } = props;

  /**
   * We don't really need the `url` to get the attributes here so set
   * it to an empty string to just make typescript happy
   */
  const attributes = getResolvedAttributes({
    url: ''
  }, details);
  return /*#__PURE__*/React.createElement(AnalyticsContext, {
    data: {
      attributes,
      component: 'relatedLink'
    }
  }, children);
};